module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2019_11.8d61bdea.jpg";